import { logError } from '@databases/logs';

/**
 * Returns the current space key in embed entrypoint
 */
export function getCurrentSpace(): { key: string } {
  const queryParams = new URLSearchParams(window.location.search);
  const spaceKey = queryParams.get('spaceKey');
  if (!spaceKey) {
    const error = new Error('URL does not have space key');
    logError(error);
    throw error;
  }
  return { key: spaceKey };
}

/**
 * Return the top window
 */
export function getWindow(): Window {
  try {
    return window.top && window.location.toString() != window.top.location.toString()
      ? window.top
      : window;
  } catch {
    // If we're in an iframe and the parent is on a different domain, we can't access it.
    // In this case we fall back to the current window. This covers the case where the app is
    // embedded in a different domain (e.g. in a different tenant) via smartlink.
    return window;
  }
}
